import { useAuth } from "@/hooks/useAuth";
import { Navigate, useLocation } from "react-router-dom";
import { getAuthEntryUrl } from "@/lib/access-flow";
import type { ReactNode } from "react";

/** Own-account access is session-scoped; existing RPC/RLS enforce ownership. */
export default function AccountAccess({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return null;
  if (!user) return <Navigate to={getAuthEntryUrl("user", `${location.pathname}${location.search}`)} replace />;
  return <>{children}</>;
}